export const UPDATE_COMPANY_ATTEMPT = 'UPDATE_COMPANY_ATTEMPT';
export type UPDATE_COMPANY_ATTEMPT = typeof UPDATE_COMPANY_ATTEMPT;

export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export type UPDATE_COMPANY_SUCCESS = typeof UPDATE_COMPANY_SUCCESS;

export const UPDATE_COMPANY_FAILURE = 'UPDATE_COMPANY_FAILURE';
export type UPDATE_COMPANY_FAILURE = typeof UPDATE_COMPANY_FAILURE;

export const UPDATE_COMPANY_CLEAR_ERRORS = 'UPDATE_COMPANY_CLEAR_ERRORS';
export type UPDATE_COMPANY_CLEAR_ERRORS = typeof UPDATE_COMPANY_CLEAR_ERRORS;



// WEBPACK FOOTER //
// ./src/actions/company/update/Types.tsx